import { useQuery } from "@tanstack/react-query";
import { getJobStatus } from "./api-service";

export const useGetJobStatus = (
  tenantId: string,
  batchId: string,
  refetchInterval: number = 5000,
  enabled: boolean = true
) =>
  useQuery({
    queryKey: ["jobStatus", batchId],
    queryFn: () => getJobStatus(tenantId, batchId),
    refetchInterval: refetchInterval,
    enabled: enabled,
    refetchIntervalInBackground: true,
  });
